class AkoProductTabs extends HTMLElement {
  connectedCallback() {
    this._abort = new AbortController();
    const { signal } = this._abort;

    // ── Tab switching (PC) ──────────────────────────────────────
    const tabBtns = this.querySelectorAll(".tab-btn");
    const tabPanels = this.querySelectorAll(".tab-panel");

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        tabBtns.forEach((b) => {
          b.classList.remove("is-active");
          b.setAttribute("aria-selected", "false");
        });
        tabPanels.forEach((p) => p.classList.remove("is-active"));

        btn.classList.add("is-active");
        btn.setAttribute("aria-selected", "true");

        const target = this.querySelector(`.tab-panel[data-tab-id="${btn.dataset.tabId}"]`);
        if (target) target.classList.add("is-active");
      }, { signal });
    });

    // ── Keyboard navigation for tabs ───────────────────────────
    tabBtns.forEach((btn, index) => {
      btn.addEventListener("keydown", (e) => {
        const map = {
          ArrowRight: (index + 1) % tabBtns.length,
          ArrowLeft: (index - 1 + tabBtns.length) % tabBtns.length,
          Home: 0,
          End: tabBtns.length - 1,
        };
        if (e.key in map) {
          e.preventDefault();
          tabBtns[map[e.key]].focus();
          tabBtns[map[e.key]].click();
        }
      }, { signal });
    });

    // ── Accordion (Mobile) ──────────────────────────────────────
    this.querySelectorAll(".accordion-trigger").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const expanded = trigger.getAttribute("aria-expanded") === "true";
        const body = this.querySelector(`#${trigger.getAttribute("aria-controls")}`);
        if (!body) return;
        trigger.setAttribute("aria-expanded", expanded ? "false" : "true");
        body.classList.toggle("is-open", !expanded);
      }, { signal });
    });
  }

  disconnectedCallback() {
    this._abort?.abort();
  }
}

customElements.define("ako-product-tabs", AkoProductTabs);
